import React, { PureComponent } from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { defineMessages, injectIntl, WrappedComponentProps } from 'react-intl';

const messages = defineMessages({
  defaultError: {
    id: 'errorBoundary.defaultErrorMessage',
    defaultMessage: 'An error has occurred',
  },
});

export interface ErrorBoundaryOwnProps {
  errorMessage?: string;
  children: any;
}

export type ErrorBoundaryState = {
  hasError: boolean;
};

export type ErrorBoundaryProps = ErrorBoundaryOwnProps & WrappedComponentProps;

class ErrorBoundary extends PureComponent<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  componentDidCatch(e: any) {
    this.setState({ hasError: true });
    console.error(e);
  }

  render() {
    return !this.state.hasError ? (
      this.props.children
    ) : (
      <Text size="headline">
        {this.props.errorMessage ||
          this.props.intl.formatMessage(messages.defaultError)}
      </Text>
    );
  }
}

export default injectIntl(ErrorBoundary);
